import { useMutation, useQueryClient } from '@tanstack/react-query';
import { notifications } from '@mantine/notifications';
import { useTranslation } from 'react-i18next';
import { AlertApi } from '../../../apis/AlertApi/AlertApi';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { AppMedError } from '../../../error/AppMedError';

export interface INotifyAssistantFromAlertVariables {
    id: number;
    message: string;
}

export function useNotifyAssistantFromAlert() {
    const queryClient = useQueryClient();
    const { t } = useTranslation();

    return useMutation<void, AppMedError, INotifyAssistantFromAlertVariables>({
        mutationKey: [QueryKeys.alerts, 'notifyAssistant'],
        mutationFn: async ({ id, message }: INotifyAssistantFromAlertVariables) => {
            return await AlertApi.notifyAssistant(id, message);
        },
        onSuccess: (_data, variables) => {
            queryClient.invalidateQueries({ queryKey: [QueryKeys.alertDetail, variables.id] });
            queryClient.invalidateQueries({ queryKey: [QueryKeys.alerts] });
            notifications.show({
                title: t('notification.success'),
                message: t('alert.notifications.assistantNotified'),
                color: 'green',
            });
        },
        onError: (error: AppMedError) => {
            notifications.show({
                title: t('notification.error'),
                message: error?.message || t('notification.error'),
                color: 'red',
            });
        },
    });
}
